import throttle from "lodash/throttle";
import { useEffect, useState } from "react";

import { getThemeBreakpoint } from "@/utils/theme-tokens";

type Breakpoint = "sm" | "md" | "lg" | "xl" | "2xl";

const getScreens = () => ({
  sm: getThemeBreakpoint("sm"),
  md: getThemeBreakpoint("md"),
  lg: getThemeBreakpoint("lg"),
  xl: getThemeBreakpoint("xl"),
  "2xl": getThemeBreakpoint("2xl"),
});

const getDeviceConfig = (width: number): Breakpoint => {
  const screens = getScreens();
  const ordered: Array<[Breakpoint, number]> = [
    ["sm", screens.sm],
    ["md", screens.md],
    ["lg", screens.lg],
    ["xl", screens.xl],
    ["2xl", screens["2xl"]],
  ];

  for (const [breakpoint, maxWidth] of ordered) {
    if (width < maxWidth) {
      return breakpoint;
    }
  }

  return "2xl";
};

export const useTailwindBreakpoint = () => {
  const [dimensions, setDimensions] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    height: typeof window !== "undefined" ? window.innerHeight : 0,
  });

  const handleResize = throttle(function () {
    setDimensions({
      width: typeof window !== "undefined" ? window.innerWidth : 0,
      height: typeof window !== "undefined" ? window.innerHeight : 0,
    });
  }, 200);

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);

    return () => window.removeEventListener("resize", handleResize, false);
  }, []);

  return getDeviceConfig(dimensions.width);
};
